export const ShowPassword = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_8574_246)">
      <path
        d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
        fill="#343A3D"
      />
    </g>
    <defs>
      <clipPath id="clip0_8574_246">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const HidePassword = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 22 20"
    fill="none"
  >
    <path
      d="M15.1 10.6001L13.65 9.1501C13.8 8.36677 13.575 7.63343 12.975 6.9501C12.375 6.26676 11.6 6.0001 10.65 6.1501L9.2 4.7001C9.48333 4.56676 9.77083 4.46676 10.0625 4.4001C10.3542 4.33343 10.6667 4.3001 11 4.3001C12.25 4.3001 13.3125 4.7376 14.1875 5.6126C15.0625 6.4876 15.5 7.5501 15.5 8.8001C15.5 9.13343 15.4667 9.44593 15.4 9.7376C15.3333 10.0293 15.2333 10.3168 15.1 10.6001ZM18.3 13.7501L16.85 12.3501C17.4833 11.8668 18.0458 11.3376 18.5375 10.7626C19.0292 10.1876 19.45 9.53343 19.8 8.8001C18.9667 7.11677 17.7708 5.77926 16.2125 4.7876C14.6542 3.79593 12.9167 3.3001 11 3.3001C10.5167 3.3001 10.0417 3.33343 9.575 3.4001C9.10833 3.46676 8.65 3.56676 8.2 3.7001L6.65 2.1501C7.33333 1.86676 8.03333 1.65426 8.75 1.5126C9.46667 1.37093 10.2167 1.3001 11 1.3001C13.5167 1.3001 15.7583 1.99593 17.725 3.3876C19.6917 4.77926 21.1167 6.58343 22 8.8001C21.6167 9.78343 21.1125 10.6959 20.4875 11.5376C19.8625 12.3793 19.1333 13.1168 18.3 13.7501ZM18.8 19.9001L14.6 15.7501C14.0167 15.9334 13.4292 16.0709 12.8375 16.1626C12.2458 16.2543 11.6333 16.3001 11 16.3001C8.48333 16.3001 6.24167 15.6043 4.275 14.2126C2.30833 12.8209 0.883333 11.0168 0 8.8001C0.35 7.91677 0.791667 7.09593 1.325 6.3376C1.85833 5.57926 2.46667 4.9001 3.15 4.3001L0.4 1.5001L1.8 0.100098L20.2 18.5001L18.8 19.9001ZM4.55 5.7001C4.06667 6.13343 3.625 6.60843 3.225 7.1251C2.825 7.64177 2.48333 8.2001 2.2 8.8001C3.03333 10.4834 4.22917 11.8209 5.7875 12.8126C7.34583 13.8043 9.08333 14.3001 11 14.3001C11.3333 14.3001 11.6583 14.2793 11.975 14.2376C12.2917 14.1959 12.6167 14.1501 12.95 14.1001L12.05 13.1501C11.8667 13.2001 11.6917 13.2376 11.525 13.2626C11.3583 13.2876 11.1833 13.3001 11 13.3001C9.75 13.3001 8.6875 12.8626 7.8125 11.9876C6.9375 11.1126 6.5 10.0501 6.5 8.8001C6.5 8.61677 6.5125 8.44176 6.5375 8.2751C6.5625 8.10843 6.6 7.93343 6.65 7.7501L4.55 5.7001Z"
      fill="#808080"
    />
  </svg>
)

export const LoadingSpinner = ({fillColor}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_9690_3779"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_9690_3779)">
      <path
        d="M9.99935 18.3334C8.86046 18.3334 7.78407 18.1147 6.77018 17.6772C5.75629 17.2397 4.87088 16.6424 4.11393 15.8855C3.35699 15.1286 2.75977 14.2431 2.32227 13.2292C1.88477 12.2154 1.66602 11.139 1.66602 10.0001C1.66602 8.8473 1.88477 7.76744 2.32227 6.7605C2.75977 5.75355 3.35699 4.87161 4.11393 4.11466C4.87088 3.35772 5.75629 2.7605 6.77018 2.323C7.78407 1.8855 8.86046 1.66675 9.99935 1.66675C10.2355 1.66675 10.4334 1.74661 10.5931 1.90633C10.7528 2.06605 10.8327 2.26397 10.8327 2.50008C10.8327 2.73619 10.7528 2.93411 10.5931 3.09383C10.4334 3.25355 10.2355 3.33341 9.99935 3.33341C8.15213 3.33341 6.57921 3.98272 5.2806 5.28133C3.98199 6.57994 3.33268 8.15286 3.33268 10.0001C3.33268 11.8473 3.98199 13.4202 5.2806 14.7188C6.57921 16.0174 8.15213 16.6667 9.99935 16.6667C11.8466 16.6667 13.4195 16.0174 14.7181 14.7188C16.0167 13.4202 16.666 11.8473 16.666 10.0001C16.666 9.76397 16.7459 9.56605 16.9056 9.40633C17.0653 9.24661 17.2632 9.16675 17.4993 9.16675C17.7355 9.16675 17.9334 9.24661 18.0931 9.40633C18.2528 9.56605 18.3327 9.76397 18.3327 10.0001C18.3327 11.139 18.1139 12.2154 17.6764 13.2292C17.2389 14.2431 16.6417 15.1286 15.8848 15.8855C15.1278 16.6424 14.2459 17.2397 13.2389 17.6772C12.232 18.1147 11.1521 18.3334 9.99935 18.3334Z"
        fill={fillColor || "white"}
      ><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 10 10;360 10 10"/></path>
    </g>
  </svg>
)

export const LoadingIcon = () => (
  <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
            <stop stopColor="#FF861A" stopOpacity="0" offset="0%"/>
            <stop stopColor="#FF861A" stopOpacity=".631" offset="63.146%"/>
            <stop stopColor="#FF861A" offset="100%"/>
        </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)">
            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" strokeWidth="2">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="0.9s"
                    repeatCount="indefinite" />
            </path>
            <circle fill="#FF861A" cx="36" cy="18" r="1">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="0.9s"
                    repeatCount="indefinite" />
            </circle>
        </g>
    </g>
  </svg>
)

export const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" style={{overflow: "visible"}}>
    <g clip-path="url(#clip0_5614_196)">
      <path d="M5.4 7.8H6.6V9H5.4V7.8ZM5.4 3H6.6V6.6H5.4V3ZM5.994 0C2.682 0 0 2.688 0 6C0 9.312 2.682 12 5.994 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 5.994 0ZM6 10.8C3.348 10.8 1.2 8.652 1.2 6C1.2 3.348 3.348 1.2 6 1.2C8.652 1.2 10.8 3.348 10.8 6C10.8 8.652 8.652 10.8 6 10.8Z" fill="#F33D62"/>
    </g>
    <defs>
      <clipPath id="clip0_5614_196">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)